import { CONSIGNMENT_ONBOARDING_TAB } from "@/core/helpers/consignmentOnboardingTab";
import { ConsignmentOnboardingPage } from "@/features/consignment-onboarding/pages/ConsignmentOnboardingPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Unknown tab falls back.
const SELECTABLE_ONBOARDING_TABS: string[] = Object.values(
	CONSIGNMENT_ONBOARDING_TAB,
);

export const Route = createFileRoute("/admin/consignment-onboarding/")({
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: SELECTABLE_ONBOARDING_TABS.find(
			(onboardingTab) => onboardingTab === search.tab,
		),
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: {
					operator: "OR",
					permissions: [
						"consignment_setup.view",
						"consignment_setup.update",
						"consignment_pilot_invite.view",
					],
				},
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentOnboardingPage,
});
